import { render, staticRenderFns } from "./addWorker.vue?vue&type=template&id=6daef76a&scoped=true&"
import script from "./addWorker.vue?vue&type=script&lang=js&"
export * from "./addWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daef76a",
  null
  
)

export default component.exports